'use strict'

/**
 * ScrollPerformance Class
 * ===========================================
 *
 * @constructor
 */
export default class ScrollPerformance {
  constructor(options = {}) {
    this.setupEvents()
  }

  onScroll() {
    clearTimeout(this.timer)
    if (!~document.body.className.indexOf('u-disable-hover')) {
      document.body.classList.add('u-disable-hover')
    }
    this.timer = setTimeout(() => {
      document.body.classList.remove('u-disable-hover')
    }, 200)
  }

  setupEvents() {
    window.addEventListener('optimizedScroll', this.onScroll.bind(this), false)
  }

  destroy() {
    window.removeEventListener('optimizedScroll', this.onScroll.bind(this), false)
  }
}
